module.exports = __webpack_public_path__ + "images/application/i-success-stroke-59da0280.svg";